import { rollbarError } from "./utils/rollbarErrors";

export function exposeGlobals(): void {
  if (typeof window !== "undefined") {
    window["rollbarError"] = rollbarError;
    window["get_auid"] = function () {
      return sv.get_auid();
    };
    window["gtag"] = function () {
      dataLayer.push(arguments); // eslint-disable-line
    };
  }
}
